import React from 'react';
import { useSelector } from 'react-redux';
import { getPageByIdOrActive } from 'app/stores/selectors';
import { Marker } from './Marker';
export const Marks = (props) => {
    const { slideId, dataKey } = props;
    const marks = useSelector(state => { var _a; return (_a = getPageByIdOrActive(state, slideId)) === null || _a === void 0 ? void 0 : _a[dataKey]; });
    return React.createElement("g", null, marks && marks.map(id => React.createElement(Marker, { key: id, id: id })));
};
